import { type ProgramEventInvitee, getUserName, isRegisteredProgramInvitee } from 'models';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Delete2LineIcon, Modal, message } from 'ui';
import { useUpdateEventInviteeRole } from '../../../../queries';

export const useDeleteEventInvitee = () => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const { isPending: isLoadingDeletingRole, mutateAsync: deleteEventInvitee } = useUpdateEventInviteeRole();

  const confirm = useCallback(
    ({ eventId, invitee }: { eventId: string; invitee: ProgramEventInvitee }) => {
      // TODO: Find place for this
      const userFullNameOrEmail = isRegisteredProgramInvitee(invitee) ? getUserName(invitee) : invitee.email;

      const handleDeleteEventInvitee = async () =>
        deleteEventInvitee(
          {
            emailInvitees: isRegisteredProgramInvitee(invitee) ? [] : [{ ...invitee, eventRole: null }],
            eventId,
            invitees: isRegisteredProgramInvitee(invitee) ? [{ ...invitee, eventRole: null }] : [],
          },
          {
            onError() {
              message.error(
                t('Something went wrong. {{name}} couldn’t be removed from event', {
                  name: userFullNameOrEmail,
                }),
              );
            },
            onSuccess() {
              message.success(
                t('{{name}} removed from event successfully', {
                  name: userFullNameOrEmail,
                }),
              );
            },
          },
        );

      modal.confirm({
        content: 'You can invite this user again at any time.',
        icon: <Delete2LineIcon type="error" />,
        okText: 'Remove',
        onOk: handleDeleteEventInvitee,
        title: t('Are you sure you want to remove {{name}} from this event?', {
          name: userFullNameOrEmail,
        }),
        type: 'error',
      });
    },
    [deleteEventInvitee, modal, t],
  );

  return useMemo(
    () => ({ confirm, contextHolder, isLoadingDeletingRole }),
    [confirm, contextHolder, isLoadingDeletingRole],
  );
};
